import SuspenseLoader from 'component/base/Loading/SuspenseLoader';
import React, { memo } from 'react';

import { ContentContainer, ContentWidth } from './styles';
import { IContentLayout, MarginLeft, Padding, Width } from './types';

/**
 * Layout of the main content section of the beecastle app.
 * FlexBox vertical container with centered inner container of variable width.
 *
 * @param props.children react children.
 * @param props.className react className prop.  Is passed to  container.
 * @param props.error an error component to render instead of children.  Currently
 *  used for api generated 404 errors and routing generated 401 errors.
 * @param props.paddingType (large | small) - padding type to apply to content container.
 *  'large' typically used for web app with header.  'small' used for teams dashboard tabs.
 * @param props.widthType (full | small | medium).  Max width setting for the content container.
 *  full applies 100% max-width.  small & medium usually used for dashboard or
 *  teams tabs layouts.  small is used to offset the width of an additional left nav
 *  panel as can be seen in PanelLayout.
 * @param props.containerProps any reflexbox BoxProps to be passed to container component.
 * @param props.widthProps any reflexbox BoxProps to be passed to width component.
 */
const ContentLayout = ({
  children,
  className,
  containerProps = {},
  error: Error = null,
  marginLeftType = MarginLeft.LEFT_NAV,
  paddingType = Padding.LARGE,
  widthProps = {},
  widthType = Width.FULL,
}: IContentLayout): JSX.Element => {
  return (
    <ContentContainer
      className={className}
      marginLeftType={marginLeftType}
      paddingType={paddingType}
      {...containerProps}
    >
      <ContentWidth widthType={widthType} {...widthProps}>
        {Error ? (
          <SuspenseLoader>
            <Error />
          </SuspenseLoader>
        ) : (
          children
        )}
      </ContentWidth>
    </ContentContainer>
  );
};

export default memo(ContentLayout);
